import { render, staticRenderFns } from "./create-registration-form.vue?vue&type=template&id=45e2ff74&scoped=true"
import script from "./create-registration-form.vue?vue&type=script&lang=js"
export * from "./create-registration-form.vue?vue&type=script&lang=js"
import style0 from "./create-registration-form.vue?vue&type=style&index=0&id=45e2ff74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e2ff74",
  null
  
)

export default component.exports